/**
 * Constants
 *
 * @desc Sentry constants
 */

export default {
  RELEASE: `awd-waternet-nl@${process.env.APP_VERSION}`,
  DSN: 'https://feff505fab934dd792b59a185de1decb@o281606.ingest.sentry.io/4504276253147136',
  ENVIRONMENTS: {
    development: [
      'localhost',
      'awd.waternet.nl.local'
    ],
    test: [
      'awd.waternet.nl.test.uselab.com'
    ],
    acceptance: [
      'acceptatie-awd.waternet.nl'
    ],
    production: [
      'awd.waternet.nl'
    ]
  }
}
